import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import './App.css';

const NotFoundPage = () => {

  useEffect(() => {
    console.log('Developed by Hated Code');
  }, []);

  return (
    <Container fluid className="h-100 d-flex align-items-center justify-content-center">
      <div className="content">
        <h1 className="mb-4" style={{ fontSize: '4rem' }}>404</h1>
        <img src="404.gif" alt="404.gif" className="mb-4" style={{ width: '350px', height: '350px' }} />
        <p className="text-white" style={{ fontSize: '1.5rem' }}>The website you're trying to visit is either missing or temporarily unavailable.</p>
        </div>
    </Container>
  );
};

export default NotFoundPage;